module.exports = __webpack_public_path__ + "img/img1.3c5d847a.svg";